import { createAsyncThunk } from "@reduxjs/toolkit";
import { setRescheduledDays, updateRescheduledDays } from "./rescheduledDaysSlice";
import request from "service";
import { INonWorkingDaysPayload } from "../../NonWorkingDays/types";
import { IRescheduledDaysCreatePayload } from "../types";
import dayjs from "dayjs";
import { renderErrorMessages } from "@utils/renderErrorMessages";
import { getErrorMessages } from "@utils/getErrorMessages";
import { t } from "i18next";
import { IBaseError } from "types";
import { toast } from "react-hot-toast";

const GetRescheduledDays = createAsyncThunk(
    "rescheduledDays/getRescheduledDays",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get("/academic-calendar-days");

            let filteredData = response.data.filter((item: INonWorkingDaysPayload) => item.kind === "rescheduled");

            dispatch(setRescheduledDays(filteredData));
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const CreateRescheduledDays = createAsyncThunk(
    "rescheduledDays/createRescheduledDays",
    async (data: IRescheduledDaysCreatePayload, { rejectWithValue }) => {
        try {
            const response = await request.post("/academic-calendar-days", data);
            return response.data;
        } catch (error) {
            if ((error as any).status === 500) {
                toast.error(t("messages.unexpected_fail"));
            } else {
                renderErrorMessages(getErrorMessages((error as any).response.data as unknown as IBaseError), t);
            }
            return rejectWithValue(error);
        }
    }
);

const UpdateRescheduledDays = createAsyncThunk(
    "rescheduledDays/updateRescheduledDays",
    async (
        rescheduledDaysData: {
            id: number;
            academic_year_id: number;
            kind: string;
            date: string;
            rescheduled_to: string;
            year_to_id: number;
        },
        { dispatch, rejectWithValue }
    ) => {
        try {
            const preparedData = {
                id: rescheduledDaysData.id,
                academic_year_id: rescheduledDaysData.academic_year_id,
                kind: rescheduledDaysData.kind,
                date: dayjs(rescheduledDaysData.date).format("YYYY-MM-DD"),
                rescheduled_to: dayjs(rescheduledDaysData.rescheduled_to).format("YYYY-MM-DD"),
                year_to_id: rescheduledDaysData.year_to_id,
            };
            const response = await request.post(`/academic-calendar-days`, preparedData);
            dispatch(updateRescheduledDays({ updatedRescheduledDays: response.data }));
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const DeleteRescheduledDays = createAsyncThunk(
    "rescheduledDays/deleteRescheduledDays",
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await request.delete(`/academic-calendar-days/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const EditRescheduledDays = createAsyncThunk(
    "rescheduledDays/editRescheduledDays",
    async (data: any, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`academic-calendar-days/rescheduled/update/`, data);
            dispatch(updateRescheduledDays({ updatedRescheduledDays: response.data }));
            return response.data;
        } catch (error) {
            if ((error as any).status === 500) {
                toast.error(t("messages.unexpected_fail"));
            } else {
                console.log((error as any).response.data);
                renderErrorMessages(getErrorMessages((error as any).response.data as unknown as IBaseError), t);
            }
            return rejectWithValue(error);
        }
    }
);

export { GetRescheduledDays, CreateRescheduledDays, UpdateRescheduledDays, DeleteRescheduledDays, EditRescheduledDays };
